import ProductTemplateSimple from "../templates/product-template-simple";
import { Eatonmcb } from '../data/products'
function ProductEatonMcb() {
    return (
        <>
            <ProductTemplateSimple data = {Eatonmcb}/>
        </>
    )
}

export default ProductEatonMcb;